import { TFunction } from "@outschool/localization";
import React from "react";

export function useRandomDidYouKnowFact(t: TFunction): () => string {
  return React.useCallback(() => {
    const QUIZ_DID_YOU_KNOW_FACTS = [
      t(
        "Honey never spoils — archaeologists have found edible honey in ancient Egyptian tombs.",
      ),
      t(
        "Octopuses have three hearts, blue blood, and neurons distributed in their arms.",
      ),
      t(
        "A group of flamingos is called a flamboyance — fitting for such colorful birds.",
      ),
      t(
        "Bananas are berries, but strawberries are not — botany likes to keep you guessing.",
      ),
      t(
        "Wombat poop is cube-shaped, which helps it stay put on slopes and mark territory.",
      ),
      t(
        "Sharks have been around longer than trees — and way longer than dinosaurs.",
      ),
      t(
        "Your brain uses about 20% of your body’s calories even though it is only about 2% of your weight.",
      ),
      t(
        "The hottest planet in our solar system is Venus — its thick atmosphere traps heat like a greenhouse.",
      ),
      t(
        "A day on Venus is longer than a year on Venus — it spins slowly but orbits the Sun faster than it rotates.",
      ),
      t(
        "Dolphins learn unique whistles that work like names — they notice when others use their signature sound.",
      ),
      t(
        "Polar bear fur is not white — each hair is hollow and clear, and light scatters to look white.",
      ),
      t(
        "Oxford University is older than the Aztec Empire — teaching there dates back to at least the 1000s.",
      ),
    ];
    const i = Math.floor(Math.random() * QUIZ_DID_YOU_KNOW_FACTS.length);
    return QUIZ_DID_YOU_KNOW_FACTS[i];
  }, [t]);
}
